<template>
  <div class="asset-count-table-cell">
    <div class="status" v-if="state === 'ACTIVE'">
      <!-- <el-tooltip class="item" content="Investigate this anomalous detection." placement="top" :enterable="false">
        <el-button class="add-button" size="small" @click="gotoThreatHunting">
          Investigate
        </el-button>
      </el-tooltip> -->
      <el-tooltip class="item" content="Click to dismiss this anomalous detection." placement="top" :enterable="false">
        <el-button class="dismiss-button" size="small" @click="confirm">
          Dismiss
        </el-button>
      </el-tooltip>
    </div>
    <div class="status" v-else>
      <span>DISMISSED</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DISMISS_ANOMALIES_REQ } from '@/store/modules/anomalies/anomalies.type'
import expandedAnomalyDetectionMixin from '@/components/expand/expandedAnomalyDetectionMixin'

export default {
  name: 'AnomalyDismissTableCell',
  mixins: [expandedAnomalyDetectionMixin],
  props: {
    entities: {
      type: Object
    },
    state: {
      type: String
    },
    uid: {
      type: String
    }
  },
  data () {
    return {}
  },
  methods: {
    confirm () {
      let vm = this
      this.$confirm(`Are you sure you want to dismiss this anomaly?`, 'Dismiss Anomaly Detection', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        callback: function (action) {
          if (action === 'confirm') {
            vm.dismissAnomaly()
          } else if (action === 'cancel') {
            vm.$message({
              type: 'info',
              message: `Operation canceled`
            })
          }
        }
      })
    },
    dismissAnomaly () {
      this.$store.dispatch(DISMISS_ANOMALIES_REQ, { uid: this.uid }).then(resp => {
        // this.anomaly.state = 'INACTIVE'
      })
    }
  },
  mounted () {},
  computed: {
    ...mapGetters(['anomaliesDateRangeUserSetting'])
  }
}
</script>

<style scoped>
.add-button {
  color: white;
  border-color: #1a90fa;
  background: #1a90fa;
  border-radius: 2px;
  padding: 8px;
  font-weight: bold;
  font-size: 13px;
  opacity: 0.87;
}

.dismiss-button {
  border: none;
  background: transparent;
  color: #1a90fa;
  font-weight: bold;
  text-align: center;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/AnomalyDismissTableCell.vue